export const API_PATH_LOGIN = "/api/login";
export const API_PATH_CONTACT = "/api/contact";
export const API_PATH_REQUEST_NEW_PASSWORD = "/api/request-password-email";
export const API_PATH_UNSUBSCRIBE = "/api/unsubscribe";
export const API_PATH_CHECK_PAYMENT = "/api/check-payment";
export const API_PATH_PAYMENT = "/api/payment";
export const API_PATH_TRACKING = "/api/tracking";
export const API_PATH_UPDATE_PASSWORD = "/api/reset-password";

export const getResumePath = (business: string, id: string) =>
  `/api/${business}/onboarding/customers/${id}/resume`;
